import { ActionTypes } from './constants';

export const abReducer = (state = {}, action = {}) => {
    switch (action.type) {
        case ActionTypes.RECEIVED_ASSIGNMENTS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
